import { Accordion, AccordionDetails, AccordionSummary, Box, MenuItem, Paper, Select, Typography } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SettingsIcon from '@mui/icons-material/Settings';
import { useEffect, useRef, useState } from "react";

// [id in selectedRatesVersion, insurer key in insurerRates] - every insurer whose version
// selector this component renders.
const RATE_VERSION_KEYS = [
  ['lifeline', 'lifeline_rates'],
  ['lifeline_assistance_cover', 'lifeline_assistance_cover_rates'],
  ['bwho', 'bwho_rates'],
  ['bwho_assistance_cover', 'bwho_assistance_cover_rates'],
  ['company', 'company_rates'],
  ['company_assistance_cover', 'company_assistance_cover_rates'],
  ['oil_gas', 'oil_gas_rates'],
  ['first_choice', 'first_choice_rates'],
  ['ihhp', 'ihhp_rates'],
  ['bhp_indonesia', 'bhp_indonesia_rates'],
  ['vumi', 'vumi_rates'],
  ['my_health_indonesia', 'my_health_indonesia_rates'],
  ['my_health_singapore', 'my_health_singapore_rates'],
  ['my_health_vietnam', 'my_health_vietnam_rates'],
  ['my_health_philippines', 'my_health_philippines_rates'],
  ['optimum_global', 'optimum_global_rates'],
  ['morgan_price', 'morgan_price_rates'],
  ['pro_medico', 'pro_medico_rates'],
  ['cigna_care_connect', 'cigna_care_connect_rates'],
  ['allianz_care_singapore', 'allianz_care_singapore_rates'],
  ['pacific_cross_primary_care_plan', 'pacific_cross_primary_care_plan_rates'],
  ['pacific_cross_select', 'pacific_cross_select_rates'],
  ['pacific_cross_blue_royale', 'pacific_cross_blue_royale_rates'],
  ['cigna_global_health_option', 'cigna_global_health_option_rates'],
  ['hsbc_smart_care_optimum_enhanced', 'hsbc_smart_care_optimum_enhanced_rates'],
];

export default function RatesSettings({ sx, insurerRates, selectedRatesVersion, setSelectedRatesVersion, setShowRefreshNow, handleFetchAppConfig, resetRatesVersionSignal }) {
  const [lifelineRates, setLifelineRates] = useState([]);

  const [lifelineAssistanceCoverRates, setLifelineAssistanceCoverRates] = useState([]);

  const [bwhoRates, setBwhoRates] = useState([]);

  const [bwhoAssistanceCoverRates, setBwhoAssistanceCoverRates] = useState([]);

  const [companyRates, setCompanyRates] = useState([]);

  const [companyAssistanceCoverRates, setCompanyAssistanceCoverRates] = useState([]);

  const [oilGasRates, setOilGasRates] = useState([]);

  const [firstChoiceRates, setFirstChoiceRates] = useState([]);

  const [ihhpRates, setIhhpRates] = useState([]);

  const [bhpIndonesiaRates, setBhpIndonesiaRates] = useState([]);

  const [vumiRates, setVumiRates] = useState([]);

  const [myHealthIndonesiaRates, setMyHealthIndonesiaRates] = useState([]);

  const [myHealthSingaporeRates, setMyHealthSingaporeRates] = useState([]);

  const [myHealthVietnamRates, setMyHealthVietnamRates] = useState([]);

  const [myHealthPhilippinesRates, setMyHealthPhilippinesRates] = useState([]);

  const [optimumGlobalRates, setOptimumGlobalRates] = useState([]);

  const [morganPriceRates, setMorganPriceRates] = useState([]);

  const [proMedicoRates, setProMedicoRates] = useState([]);

  const [cignaCareConnectRates, setCignaCareConnectRates] = useState([]);

  const [allianzCareSingaporeRates, setAllianzCareSingaporeRates] = useState([]);

  const [pacificCrossPrimaryCarePlanRates, setPacificCrossPrimaryCarePlanRates] = useState([]);

  const [pacificCrossSelectRates, setPacificCrossSelectRates] = useState([]);

  const [pacificCrossBlueRoyaleRates, setPacificCrossBlueRoyaleRates] = useState([]);

  const [cignaGlobalHealthOptionRates, setCignaGlobalHealthOptionRates] = useState([]);

  const [HSBC_SmartCareOptimumEnhancedRates, setHSBC_SmartCareOptimumEnhancedRates] = useState([]);

  useEffect(() => {
    setLifelineRates(getAllRatesByInsurer('lifeline_rates'));

    setLifelineAssistanceCoverRates(getAllRatesByInsurer('lifeline_assistance_cover_rates'));

    setBwhoRates(getAllRatesByInsurer('bwho_rates'));

    setBwhoAssistanceCoverRates(getAllRatesByInsurer('bwho_assistance_cover_rates'));

    setCompanyRates(getAllRatesByInsurer('company_rates'));

    setCompanyAssistanceCoverRates(getAllRatesByInsurer('company_assistance_cover_rates'));

    setOilGasRates(getAllRatesByInsurer('oil_gas_rates'));

    setFirstChoiceRates(getAllRatesByInsurer('first_choice_rates'));

    setIhhpRates(getAllRatesByInsurer('ihhp_rates'));

    setBhpIndonesiaRates(getAllRatesByInsurer('bhp_indonesia_rates'));

    setVumiRates(getAllRatesByInsurer('vumi_rates'));

    setMyHealthIndonesiaRates(getAllRatesByInsurer('my_health_indonesia_rates'));

    setMyHealthSingaporeRates(getAllRatesByInsurer('my_health_singapore_rates'));

    setMyHealthVietnamRates(getAllRatesByInsurer('my_health_vietnam_rates'));

    setMyHealthPhilippinesRates(getAllRatesByInsurer('my_health_philippines_rates'));

    setOptimumGlobalRates(getAllRatesByInsurer('optimum_global_rates'));

    setMorganPriceRates(getAllRatesByInsurer('morgan_price_rates'));

    setProMedicoRates(getAllRatesByInsurer('pro_medico_rates'));

    setCignaCareConnectRates(getAllRatesByInsurer('cigna_care_connect_rates'));

    setAllianzCareSingaporeRates(getAllRatesByInsurer('allianz_care_singapore_rates'));

    setPacificCrossPrimaryCarePlanRates(getAllRatesByInsurer('pacific_cross_primary_care_plan_rates'));

    setPacificCrossSelectRates(getAllRatesByInsurer('pacific_cross_select_rates'));

    setPacificCrossBlueRoyaleRates(getAllRatesByInsurer('pacific_cross_blue_royale_rates'));

    setCignaGlobalHealthOptionRates(getAllRatesByInsurer('cigna_global_health_option_rates'));

    setHSBC_SmartCareOptimumEnhancedRates(getAllRatesByInsurer('hsbc_smart_care_optimum_enhanced_rates'));

    if (selectedRatesVersion.lifeline === '') {
      selectedRatesVersion.lifeline = getRatesLatestVersion('lifeline_rates');
    }

    if (selectedRatesVersion.lifeline_assistance_cover === '') {
      selectedRatesVersion.lifeline_assistance_cover = getRatesLatestVersion('lifeline_assistance_cover_rates');
    }

    if (selectedRatesVersion.bwho === '') {
      selectedRatesVersion.bwho = getRatesLatestVersion('bwho_rates');
    }

    if (selectedRatesVersion.bwho_assistance_cover === '') {
      selectedRatesVersion.bwho_assistance_cover = getRatesLatestVersion('bwho_assistance_cover_rates');
    }

    if (selectedRatesVersion.company === '') {
      selectedRatesVersion.company = getRatesLatestVersion('company_rates');
    }

    if (selectedRatesVersion.company_assistance_cover === '') {
      selectedRatesVersion.company_assistance_cover = getRatesLatestVersion('company_assistance_cover_rates');
    }

    if (selectedRatesVersion.oil_gas === '') {
      selectedRatesVersion.oil_gas = getRatesLatestVersion('oil_gas_rates');
    }

    if (selectedRatesVersion.first_choice === '') {
      selectedRatesVersion.first_choice = getRatesLatestVersion('first_choice_rates');
    }

    if (selectedRatesVersion.ihhp === '') {
      selectedRatesVersion.ihhp = getRatesLatestVersion('ihhp_rates');
    }

    if (selectedRatesVersion.bhp_indonesia === '') {
      selectedRatesVersion.bhp_indonesia = getRatesLatestVersion('bhp_indonesia_rates');
    }

    if (selectedRatesVersion.vumi === '') {
      selectedRatesVersion.vumi = getRatesLatestVersion('vumi_rates');
    }

    if (selectedRatesVersion.my_health_indonesia === '') {
      selectedRatesVersion.my_health_indonesia = getRatesLatestVersion('my_health_indonesia_rates');
    }

    if (selectedRatesVersion.my_health_singapore === '') {
      selectedRatesVersion.my_health_singapore = getRatesLatestVersion('my_health_singapore_rates');
    }

    if (selectedRatesVersion.my_health_vietnam === '') {
      selectedRatesVersion.my_health_vietnam = getRatesLatestVersion('my_health_vietnam_rates');
    }

    if (selectedRatesVersion.my_health_philippines === '') {
      selectedRatesVersion.my_health_philippines = getRatesLatestVersion('my_health_philippines_rates');
    }

    if (selectedRatesVersion.optimum_global === '') {
      selectedRatesVersion.optimum_global = getRatesLatestVersion('optimum_global_rates');
    }

    if (selectedRatesVersion.morgan_price === '') {
      selectedRatesVersion.morgan_price = getRatesLatestVersion('morgan_price_rates');
    }

    if (selectedRatesVersion.pro_medico === '') {
      selectedRatesVersion.pro_medico = getRatesLatestVersion('pro_medico_rates');
    }

    if (selectedRatesVersion.cigna_care_connect === '') {
      selectedRatesVersion.cigna_care_connect = getRatesLatestVersion('cigna_care_connect_rates');
    }

    if (selectedRatesVersion.allianz_care_singapore === '') {
      selectedRatesVersion.allianz_care_singapore = getRatesLatestVersion('allianz_care_singapore_rates');
    }

    if (selectedRatesVersion.pacific_cross_primary_care_plan === '') {
      selectedRatesVersion.pacific_cross_primary_care_plan = getRatesLatestVersion('pacific_cross_primary_care_plan_rates');
    }

    if (selectedRatesVersion.pacific_cross_select === '') {
      selectedRatesVersion.pacific_cross_select = getRatesLatestVersion('pacific_cross_select_rates');
    }

    if (selectedRatesVersion.pacific_cross_blue_royale === '') {
      selectedRatesVersion.pacific_cross_blue_royale = getRatesLatestVersion('pacific_cross_blue_royale_rates');
    }

    if (selectedRatesVersion.cigna_global_health_option === '') {
      selectedRatesVersion.cigna_global_health_option = getRatesLatestVersion('cigna_global_health_option_rates');
    }

    if (selectedRatesVersion.hsbc_smart_care_optimum_enhanced === '' || selectedRatesVersion.hsbc_smart_care_optimum_enhanced === undefined) {
      selectedRatesVersion.hsbc_smart_care_optimum_enhanced = getRatesLatestVersion('hsbc_smart_care_optimum_enhanced_rates');
    }

    setSelectedRatesVersion({...selectedRatesVersion});

  }, [insurerRates]);

  // resetRatesVersionSignal changes on every "New Quotation" - unlike the mount effect
  // above, which only fills in a version when one isn't picked yet, this forces every
  // insurer back to latest even if a specific (non-latest) version was selected before.
  const isFirstResetSignalRef = useRef(true);

  useEffect(() => {
    if (isFirstResetSignalRef.current) {
      isFirstResetSignalRef.current = false;
      return;
    }

    RATE_VERSION_KEYS.forEach(([id, insurer]) => {
      selectedRatesVersion[id] = getRatesLatestVersion(insurer);
    });

    setSelectedRatesVersion({ ...selectedRatesVersion });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetRatesVersionSignal]);

  function getAllRatesByInsurer(insurer) {
    const rates = [];

    for (let i = 0; i < insurerRates.length; i++) {
      if (insurerRates[i].insurer === insurer) {
        rates.push(insurerRates[i]);
      }
    }

    return rates;
  }

  function getRatesLatestVersion(insurer) {
    const insurerRate = getRatesLatest(insurer);

    if (!insurerRate) return '';

    return insurerRate.version;
  }

  function getRatesLatest(insurer) {
    for (let i = 0; i < insurerRates.length; i++) {
      if (insurerRates[i].insurer === insurer && insurerRates[i].is_latest) {
        return insurerRates[i];
      }
    }
  }

  const InsurerRatesSetting = function ({ sx, id, label, rates, selectedRatesVersion, setSelectedRatesVersion, setShowRefreshNow }) {
    let isFound = false;

    for (let i = 0; i < rates.length; i++) {
      if (selectedRatesVersion[id] === rates[i].version) {
        isFound = true;
        break;
      }
    }

    if (!isFound) {
      for (let i = 0; i < rates.length; i++) {
        if (rates[i].insurer === id + '_rates' && rates[i].is_latest) {
          selectedRatesVersion[id] = rates[i].version;
          break;
        }
      }
    }



    return <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, ...sx }}>
      <Typography sx={{ width: 150 }}>{label}</Typography>
      <Select
        id={id + "-rates-select"}
        size='small'
        sx={{ ml: 2, fontSize: 14, minWidth: 300 }}
        value={selectedRatesVersion[id]}
        onChange={(e) => {
          selectedRatesVersion[id] = e.target.value
          setSelectedRatesVersion({
            ...selectedRatesVersion
          });

          setShowRefreshNow(true);
          handleFetchAppConfig();
        }}
      >
        {
          rates.map(rate => {
            return <MenuItem
              key={rate.id}
              value={rate.version}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {/* <CheckCircleIcon sx={{ mr: 1, color: '#4caf50', fontSize: 18 }} /> */}
                {rate.version} { rate.is_latest ? '(Latest)' : '' }
              </Box>
            </MenuItem>
          })
        }

      </Select>
    </Box>
  }


  return (
    <Paper elevation={1} sx={sx}>
      <Accordion sx={{ border: 'none', backgroundColor: '#cfd8dc' }} variant='outlined'>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />}
          aria-controls="rates-settings"
          id="rates-settings-header"

        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <SettingsIcon sx={{ color: '#bdbdbd', mr: 1, fontSize: 24 }} />
            <Typography sx={{ color: '#212121', fontSize: 14 }}>Rates Settings</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: '#fff' }}>
          <Box sx={{ display: 'flex'}}>
            <Box sx={{ mr: 4}}>
              <InsurerRatesSetting
                id='lifeline'
                label='BUPA Lifeline'
                rates={lifelineRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />

              {/* <InsurerRatesSetting
                id='lifeline_assistance_cover'
                label='BUPA Lifeline Assistance Cover'
                rates={lifelineAssistanceCoverRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              /> */}

              <InsurerRatesSetting
                id='bwho'
                label='BWHO'
                rates={bwhoRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />

              {/* <InsurerRatesSetting
                id='bwho_assistance_cover'
                label='BWHO Assistance Cover'
                rates={bwhoAssistanceCoverRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              /> */}

              <InsurerRatesSetting
                id='company'
                label='BUPA Company'
                rates={companyRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />
{/* 
              <InsurerRatesSetting
                id='company_assistance_cover'
                label='BUPA Company Assistance Cover'
                rates={companyAssistanceCoverRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              /> */}

              <InsurerRatesSetting
                id='oil_gas'
                label='Oil & Gas'
                rates={oilGasRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />

              {/* <InsurerRatesSetting
                id='first_choice'
                label='First Choice'
                rates={firstChoiceRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              /> */}

              <InsurerRatesSetting
                id='ihhp'
                label='IHHP'
                rates={ihhpRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />

              <InsurerRatesSetting
                id='bhp_indonesia'
                label='BHP Indonesia'
                rates={bhpIndonesiaRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />



            </Box>

            <Box>
              <InsurerRatesSetting
                id='vumi'
                label='VUMI'
                rates={vumiRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />

              <InsurerRatesSetting
                id='my_health_indonesia'
                label='MyHealth Indonesia'
                rates={myHealthIndonesiaRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />

              <InsurerRatesSetting
                id='my_health_singapore'
                label='MyHealth Singapore'
                rates={myHealthSingaporeRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />

              {/* <InsurerRatesSetting
                id='my_health_vietnam'
                label='MyHealth Vietnam'
                rates={myHealthVietnamRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              /> */}

              <InsurerRatesSetting
                id='my_health_philippines'
                label='MyHealth Philippines'
                rates={myHealthPhilippinesRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />

              <InsurerRatesSetting
                id='optimum_global'
                label='Optimum Global'
                rates={optimumGlobalRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />

              <InsurerRatesSetting
                id='morgan_price'
                label='Morgan Price'
                rates={morganPriceRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />
              <InsurerRatesSetting
                id='pro_medico'
                label='Libery proMedico'
                rates={proMedicoRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />
              <InsurerRatesSetting
                id='cigna_care_connect'
                label='Cigna Care Connect'
                rates={cignaCareConnectRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />
              <InsurerRatesSetting
                id='pacific_cross_primary_care_plan'
                label='Pacific Cross PrimaryCare Plan'
                rates={pacificCrossPrimaryCarePlanRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />
              <InsurerRatesSetting
                id='pacific_cross_select'
                label='Pacific Cross Select'
                rates={pacificCrossSelectRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />
              <InsurerRatesSetting
                id='pacific_cross_blue_royale'
                label='Pacific Cross Blue Royale'
                rates={pacificCrossBlueRoyaleRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />
              <InsurerRatesSetting
                id='cigna_global_health_option'
                label='Cigna Global Health Option'
                rates={cignaGlobalHealthOptionRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />
              <InsurerRatesSetting
                id='hsbc_smart_care_optimum_enhanced'
                label='HSBC SmartCare Optimum Enhanced'
                rates={HSBC_SmartCareOptimumEnhancedRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              />
              {/* <InsurerRatesSetting
                id='allianz_care_singapore'
                label='Allianz Care Singapore'
                rates={allianzCareSingaporeRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
              /> */}
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
}



